import { render, staticRenderFns } from "./withdrawModal.vue?vue&type=template&id=6fa2fa87&scoped=true"
import script from "./withdrawModal.vue?vue&type=script&lang=js"
export * from "./withdrawModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa2fa87",
  null
  
)

export default component.exports